// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"75":"bd3b9d3737f86785","79":"a4f6ddaaff0054db","752":"39b8e9c619bfb8a3","869":"4dfa3f3321b6886b","892":"4942182138f0039a","896":"14226683e7e19f03","922":"4882c8c574c03c25","929":"15793e189a9e67b3","976":"963dc7c16e88260c"}[chunkId] + ".js";
};